import MapleMarketWindow from '@/components/maple-market/MapleMarketWindow';

export const AppStore = () => {
  return <MapleMarketWindow />;
};
